import React from "react";
import ReactDOM from "react-dom/client";
import * as Sentry from "@sentry/react";
import "@/index.css";
import App from "@/App";

if (process.env.REACT_APP_SENTRY_DSN) {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
      }),
    ],
    tracesSampleRate: 0.1,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    environment: process.env.NODE_ENV,
    beforeSend(event) {
      // Ignorar errores de webkit que ocurren en navegadores que no son WebView nativo
      if (event.exception) {
        const error = event.exception.values?.[0];
        if (
          error?.value?.includes("window.webkit") ||
          error?.value?.includes("messageHandlers") ||
          (error?.value?.includes("undefined is not an object") &&
           event.contexts?.stacktrace?.frames?.some(f =>
             f.function?.includes("sendDataToNative")
           ))
        ) {
          return null; // No enviar a Sentry
        }
      }
      return event;
    },
  });

  // Exponer Sentry globalmente para testing desde DevTools
  if (typeof window !== 'undefined') {
    window.Sentry = Sentry;
  }
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
